import { useEffect, useState, useCallback } from "react";
import { useContacto } from "../../Services/Contacto";

export const useGetContacto = () => {
    const { getContacto } = useContacto();
  const [Contacto, setContacto] = useState([]);
  const [errorContacto, setErrorContacto] = useState(null);
  const [loadingContacto, setLoadingContacto] = useState(true);

  const fetchContacto = useCallback(async () => {
  setLoadingContacto(true);
  try {
    const data = await getContacto();
    setContacto(data);
  } catch (error) {
    setErrorContacto(error?.message || "Error al obtener deudores");
  } finally {
    setLoadingContacto(false);
  }
}, []); 

  useEffect(() => {
    fetchContacto();
  }, [fetchContacto]); 

  return {
    Contacto,
    errorContacto,
    loadingContacto,
    refetchContacto: fetchContacto,
  };
}
